import { Guid } from "guid-typescript";

const parseBool = (value: string | boolean | number | undefined | null): boolean => {
    if (value === undefined || value === null) return false;
    if (typeof value === "number") return value === 1;
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value.toLowerCase() === "true" || value.trim().toLowerCase() === "1";
    return false;
};

const guidIdentical = (guid1: Guid | string, guid2: Guid | string): boolean => {
    if(!guid1 || !guid2) return false;
    let val1 = guid1.toString().toLowerCase();
    let val2 = guid2.toString().toLowerCase();
    return val1 === val2;
}

const isGuid = (value: string): boolean => {
    if (value === undefined || value === null) return false;
    if (typeof value === "string") return Guid.isGuid(value);
    return false;
}

export { parseBool, guidIdentical, isGuid };
